import gql from 'graphql-tag';

export const ContentContributorsQuery = gql`
	query LivePageContentContributorsQuery($contentId: ID!) {
		contentContributors(id: $contentId) {
			isCurrentUserContributor
		}
	}
`;
